import { render, staticRenderFns } from "./ProductCardSmallImage.vue?vue&type=template&id=cca4d100&"
import script from "./ProductCardSmallImage.vue?vue&type=script&lang=js&"
export * from "./ProductCardSmallImage.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardSmallImage.vue?vue&type=style&index=0&id=cca4d100&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports